export enum SessionFileTypeEnum {
  QUOTATION_FILE = "quotation_file",
  PROGRAM = "program",
  CONVOCATION = "convocation",
  SIGN_IN_SHEET = "sign_in_sheet",
  HABILITATION_CERTIFICATE = "habilitation_certificate",
  PARTICIPATION_CERTIFICATE = "participation_certificate",
  ACHIEVEMENT_CERTIFICATE = "achievement_certificate",
  CONNEXION_LOGS = "connexion_logs",
  INVOICE = "invoice",
  GRANT_APPLICATION = "grant_application",
  OTHER = "other",
  EXPENSE = "expense",
  TRAINING_SUPPORT = "training_support",
  ABSENCE_JUSTIFICATION = "absence_justification",
  SATISFACTION_SURVEY = "satisfaction_survey",
}
